import { render } from "./SelectTrademarks.vue?vue&type=template&id=1cced1bc&scoped=true&ts=true"
import script from "./SelectTrademarks.vue?vue&type=script&lang=ts"
export * from "./SelectTrademarks.vue?vue&type=script&lang=ts"

import "./SelectTrademarks.vue?vue&type=style&index=0&id=1cced1bc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cced1bc"]])

export default __exports__